import axios from "axios";

export default {


    async recoverPasswordEmail(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/user/email/recover_password",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: JSON.stringify({ email: params.email }),
        };
        const response = await axios(config);



        //response.status = 500;

        if (response.status == 200) {
            return (await response).data;
        } else  {
            throw new Error(response.status);
        }

    },
     async cambioPassword(params){
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/user/email/password_recovery",
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: JSON.stringify({ password: params.password, token: params.token }),
        };
        const response = await axios(config);


        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
     },
     async cambioPassSesion(params){
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/user/get_token_recovery?email="+params.email,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };
        const response = await axios(config);


        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
     },
     async Slider(){
        
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/user/slide",
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            // data: JSON.stringify({ password: params.password, token: params.token }),
        };
        
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
     },

     async resendToken(params){
        
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/user/email/resend_token",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: JSON.stringify({ token: params.token }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else  {
            throw new Error(response.status);
        }
     }
};